export const PAGES = {
    HOME: '',
    LOGIN: 'login',
    DASHBOARD: 'dashboard',
    STATS: 'stats',
    ADMINS: 'admins',
    MANAGE_COMPANIES: 'manage-companies',
    NEW_COMPANIES: 'new-companies',
    PARTNER_COMPANIES: 'partner-companies',
    REPORTED_POSTS: 'reported-posts',
    REPORTED_COMPANIES: 'reported-companies',
    REPORTED_CONVERSATIONS: 'reported-conversations',
    CHANGE_PASSWORD: 'change-password',
    INDUSTRIES: 'industries',
    SECTORS: 'sectors',
    ADDITIONAL_STATS: 'additional-stats',
    DOWNLOADS: 'downloads',
    PRODUCTS: 'products',
    SURVEYS: 'surveys',
    MANAGE_AWARDS: 'manage-awards',
    MANAGE_AWARD_APPLICATIONS: 'manage-award-applications',
    DESIGN_PARTNERS: 'design-partners',
    EXTERNAL_MESSAGE_STATS: 'external-message-stats',
    VERIFICATION_REVIEWS: 'verification-reviews'
};

export const PAGE_ROUTES = {
    HOME: `/${PAGES.HOME}`,
    LOGIN: `/${PAGES.LOGIN}`,
    DASHBOARD: `/${PAGES.DASHBOARD}`,
    ADMINS: `/${PAGES.ADMINS}`,
    MANAGE_COMPANIES: `/${PAGES.MANAGE_COMPANIES}`,
    NEW_COMPANIES: `/${PAGES.NEW_COMPANIES}`,
    PARTNER_COMPANIES: `/${PAGES.PARTNER_COMPANIES}`,
    DESIGN_PARTNERS: `/${PAGES.DESIGN_PARTNERS}`,
    COMPANY: `/${PAGES.MANAGE_COMPANIES}/:id`,
    REPORTED_POSTS: `/${PAGES.REPORTED_POSTS}`,
    REPORTED_POST: `/${PAGES.REPORTED_POSTS}/:id`,
    REPORTED_COMPANIES: `/${PAGES.REPORTED_COMPANIES}`,
    REPORTED_COMPANY: `/${PAGES.REPORTED_COMPANIES}/:id`,
    REPORTED_CONVERSATIONS: `/${PAGES.REPORTED_CONVERSATIONS}`,
    REPORTED_CONVERSATION: `/${PAGES.REPORTED_CONVERSATIONS}/:id`,
    CHANGE_PASSWORD: `/${PAGES.CHANGE_PASSWORD}`,
    INDUSTRIES: `/${PAGES.INDUSTRIES}`,
    SECTORS: `/${PAGES.SECTORS}`,
    ADDITIONAL_STATS: `/${PAGES.ADDITIONAL_STATS}`,
    DOWNLOADS: `/${PAGES.DOWNLOADS}`,
    PRODUCTS: `/${PAGES.PRODUCTS}`,
    POPULAR_PRODUCTS: `/${PAGES.PRODUCTS}/:id`,
    SURVEYS: `/${PAGES.SURVEYS}`,
    MANAGE_AWARDS: `/${PAGES.MANAGE_AWARDS}`,
    MANAGE_AWARD_APPLICATIONS: `/${PAGES.MANAGE_AWARD_APPLICATIONS}`,
    EXTERNAL_MESSAGE_STATS: `/${PAGES.EXTERNAL_MESSAGE_STATS}`,
    VERIFICATION_REVIEWS: `/${PAGES.VERIFICATION_REVIEWS}`
};
